module.exports = __webpack_public_path__ + "static/media/map_marker.9a690ce3.svg";